import { RootStateOrAny, useSelector } from 'react-redux';

export default function useCampaignAccess() {
  return useSelector((state: RootStateOrAny) => state.user.campaignsAccess);
}
